import { observer } from "mobx-react-lite";
import { Box, Button } from "@mui/material";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import MyFormikController from "../shared/forms/MyFormikController";
import { useStore } from "../../api/main/appStore";
import { Link, useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import { LoginModel } from "../../api/models/authentication";
import { OtherRoutes } from "../../routes";
import { ActorTypes } from "../../data/staticData";

export default observer(function FinancierLoginForm() {
  const { financierStore } = useStore();
  const navigate = useNavigate();
  const colors = tokens();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .required("Email is required")
      .email("Must be a valid email"),

    password: Yup.string().required("Password is required"),
  });

  const handleFinancierLogin = async (values: LoginModel) => {
    const url = await financierStore.loginFinancier(values);

    if (url.length > 0) {
      navigate(url, { replace: true });
    }
  };

  return (
    <Box
      sx={{
        mt: 2,
        px: 2,
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleFinancierLogin(values)}
      >
        {() => (
          <Form>
            <MyFormikController control="input" label="Email" name="email" />

            <Box>
              <MyFormikController
                control="input-password"
                label="Password"
                name="password"
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
                my: 0.5,
              }}
            >
              <Link
                to={OtherRoutes.forgotPassword}
                state={{ actorType: ActorTypes.Financier }}
                style={{
                  textDecoration: "none",
                  color: `${colors.blue[300]}`,
                }}
              >
                Forgot Password ?
              </Link>
            </Box>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 0,
              }}
            >
              login
            </Button>
            <Box
              sx={{
                fontSize: "1.2rem",
                textAlign: "center",
                mt: 3,
              }}
            >
              Don't have an account ?{" "}
              <Link
                to={OtherRoutes.createFinancier}
                style={{
                  textDecoration: "none",
                  color: `${colors.blue[300]}`,
                }}
              >
                Signup
              </Link>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
});
